import React, { useState, useRef, useEffect } from "react";
import { graphql, Script } from "gatsby"
import { useTranslation, useI18next } from 'gatsby-plugin-react-i18next';
import { createUrlString, capitalizeWords, translateHead } from "../helpers/helpers";
import { useMixpanel } from 'gatsby-plugin-mixpanel'

import "./emoji-details.css"

import Layout from "../components/layout/layout"
import SearchBar from "../components/search/search-bar"
import EmojiCard from "../components/emoji/emoji-card"
import EmojiDescription from "../components/emoji/emoji-description"
import EmojiProperties from "../components/emoji/emoji-properties"
import Seo from "../components/seo"

const EmojiDetails = ({ pageContext }) => {
  const { emoji, relatedEmojis, categories, category } = pageContext;
  // const [activeOption, setActiveOption] = useState("description");
  const mixpanel = useMixpanel()
  const { language, navigate } = useI18next();
  const { t } = useTranslation();

  useEffect(() => {
    mixpanel.track('page_view', {
      source: 'emoji_page',
      emoji: emoji.url,
      language: language
    });
  }, [mixpanel, emoji, language]);

  const tags = (emoji.tags[language] || emoji.tags.en).map((tag) => {
    return {
      text: tag,
      link: `/tags/${createUrlString(tag)}`,
    };
  });

  const properties = (() => {
    const emojiPropertiesValue = [];

    const relatedEmojiUrlsSet = new Set();

    if (relatedEmojis) {
      relatedEmojis.forEach((relatedEmoji) => {
        if (relatedEmoji.url !== emoji.url && !relatedEmojiUrlsSet.has(relatedEmoji.url)) {
          relatedEmojiUrlsSet.add(relatedEmoji.url);

          emojiPropertiesValue.push({
            text: relatedEmoji.emoji,
            link: `/emoji/${relatedEmoji.url}`,
          });
        }
      });
    }

    const properties = [];

    if (emojiPropertiesValue.length > 0) {
      const relatedEmojisSection = {
        title: t('emoji-detail.related-emojis', { lng: language }),
        values: emojiPropertiesValue,
        valueClass: "bubble-emoji",
        bubble: true,
      };
      properties.push(relatedEmojisSection);
    }

    if (!category.hidden) {
      const categorySection = {
        title: t('emoji-detail.category', { lng: language }),
        values: [{
          text: category.name[language] || category.name.en,
          link: `/categories/${category.url}`
        }],
        bubble: true,
      };

      properties.push(categorySection);
    }

    return properties;
  })();


  const specifications = [
    {
      title: "Unicode",
      values: emoji.codes,
    },
    {
      title: "Tags",
      values: tags,
      bubble: true,
    },
  ];

  /*const handleTabChange = (optionId) => {
    setActiveOption(optionId);
  };*/

  const handleSearch = (query) => {
    navigate(`/search?query=${encodeURIComponent(query)}`);
  };

  return (
    <Layout categories={categories}>
      <section>
        <SearchBar onSearch={handleSearch} />
        <div className="row g-0">
          <div className="col content-col">
            <div className="ad-mobile mb-4">
              <div className="ad-mobile-iframe">
                <iframe
                  title="Mobile Advertisement"
                  data-aa='2310842'
                  src='//ad.a-ads.com/2310842?size=468x60'
                  style={{
                    width: '468px',
                    height: '60px',
                    border: '0px',
                    padding: '0',
                    overflow: 'hidden',
                    backgroundColor: 'transparent'
                  }}
                />
              </div>
            </div>
            <EmojiCard emoji={emoji} />
            <h1 className="mb-4 mt-4">{capitalizeWords(emoji.name[language] || emoji.name.en)}</h1>
            <EmojiDescription emoji={emoji} />
            <EmojiProperties properties={properties} />
            <EmojiProperties properties={specifications} />
            {/*<PillsSelector options={pillOptions} activeOption={activeOption} onTabChange={handleTabChange} />
            {activeOption === "description" && <EmojiDescription emoji={emoji} />}
            {activeOption === "specifications" && <EmojiProperties properties={specifications} />}
            <EmojiProperties properties={properties} /> */}
          </div>
          <div className="ad-col">
            <div className="ad-square mb-4" >
              <iframe
                title="Second Advertisement"
                data-aa='2310839'
                src='//ad.a-ads.com/2310839?size=336x280'
                style={{
                  width: '336px',
                  height: '280px',
                  border: '0px',
                  padding: '0',
                  overflow: 'hidden',
                  backgroundColor: 'transparent'
                }}
              />
            </div>
            <div className="ad-long">
              <iframe
                title="Advertisement"
                data-aa='2310838'
                src='//ad.a-ads.com/2310838?size=160x600'
                style={{
                  width: '160px',
                  height: '600px',
                  border: '0px',
                  padding: '0',
                  overflow: 'hidden',
                  backgroundColor: 'transparent'
                }}
              />
            </div>
          </div>
        </div>
      </section>
    </Layout >
  );
};

export const Head = ({ pageContext, data }) => {
  const { emoji, language, category } = pageContext;
  const pageTitle = translateHead("emoji-detail.title", language, data.locales, {
    emoji: emoji.emoji,
    emoji_name: capitalizeWords(emoji.name[language] || emoji.name.en),
    category: capitalizeWords(category.name[language] || category.name.en)
  });

  const metaDescription = translateHead("emoji-detail.description", language, data.locales, {
    emoji: emoji.emoji,
    emoji_name: capitalizeWords(emoji.name[language] || emoji.name.en),
    category: capitalizeWords(category.name[language] || category.name.en),
    tags: emoji.tags[language] || emoji.tags.en
  });

  return (
    <Seo title={pageTitle} description={metaDescription}></Seo>
  )
}

export default EmojiDetails;

export const query = graphql`
  query {
    locales: allLocale {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;